var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.174 2.835a9.827 9.827 0 01-2.512.64c.915-.51 1.609-1.29 1.934-2.245a9.3 9.3 0 01-2.79.987c-.788-.792-1.934-1.28-3.207-1.28-2.409 0-4.377 1.812-4.377 4.035 0 .326.058.63.128.923-3.647-.163-6.878-1.769-9.031-4.22-.37.607-.602 1.29-.602 2.028 0 1.41.787 2.647 1.945 3.363a4.465 4.465 0 01-1.98-.5v.055c0 .52.105.998.301 1.454.533 1.27 1.749 2.223 3.22 2.495a4.577 4.577 0 01-1.159.151 4.17 4.17 0 01-.822-.086c.568 1.605 2.177 2.776 4.088 2.82-1.506 1.085-3.381 1.725-5.43 1.725-.36 0-.695-.022-1.054-.055a13.273 13.273 0 006.715 1.812c6.842 0 11.068-4.437 12.167-9.047.198-.824.29-1.638.29-2.44v-.521a8.774 8.774 0 002.176-2.094z","fill":"currentColor","fillRule":"evenodd"}));
}

Twitter.defaultProps = {"viewBox":"0 0 23 17","width":"23","height":"17"};

module.exports = Twitter;

Twitter.default = Twitter;
